import TerminalAnimationModule from './TerminalAnimationModule';

export default TerminalAnimationModule;
